import { useAcceptsReservations } from 'reservations/account/providers/ConfigProvider';
import CreateBookingScreen from 'reservations/availabilities/components/CreateBookingScreen';
import WaitlistOnlyScreen from 'reservations/waitlist/components/WaitlistOnlyScreen';

type WaitlistOrBookingScreenProps = {
  slug: string;
};

const WaitlistOrBookingScreen = ({ slug }: WaitlistOrBookingScreenProps) => {
  const isAcceptingReservations = useAcceptsReservations();
  const Screen = isAcceptingReservations
    ? CreateBookingScreen
    : WaitlistOnlyScreen;

  return <Screen slug={slug} />;
};

export default WaitlistOrBookingScreen;
